<template>
  <post-view/>
</template>

<script>
import PostView from '../components/PostView/index'
export default {
  components: {PostView},

}
</script>

<style>

</style>
